import { Link } from "gatsby";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import bgShape from "../images/NCZ-white.png";
import parse from "html-react-parser";
//test


const limitWords = (html, wordLimit = 40) => {
  if (!html) return "";

  // Remove HTML tags
  const text = html.replace(/<[^>]*>/g, "");

  const words = text.split(" ");

  if (words.length <= wordLimit) {
    return text;
  }

  return words.slice(0, wordLimit).join(" ") + "...";
};


const FaqSection = ({
  heading,
  content,
  faqData,
  ctaHeading,
  ctaSubheading,
  ctaBtn,
  bgImage,
}) => {
  return (
    <section className="py-8" style={sectionWrapper(bgImage)}>
      {/* <section className="py-5 py-md-8"> */}
      <Container>
        <Row className="justify-content-center faq-wrapper">
          <Col lg={12}>
            <Row>
              <Col lg={5}>
                <h2 className="text-start montserrat-black text-white">
                  {heading}
                </h2>
                <p className="text-start text-white">{content}</p>
              </Col>
            </Row>

            {(faqData && faqData.length) > 0 && (
              <Row className="mt-6 faq-wrapper">
                {faqData.map((faqItems, i) => (
                  <Col md={6} xl={4} key={i} className="mb-4">
                    <div
                      className="position-relative w-100 p-4 pt-md-5 pb-md-8 p-lg-5 d-flex flex-column justify-content-start align-items-center text-center"
                      style={{
                        backgroundImage: `url(${bgShape})`,
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        aspectRatio: "1 / 1",
                      }}
                    >
                      <h6 className="text-light-black mb-3 fw-bold">
                        <Link to={`/your-questions/${faqItems.slug}`} className="text-decoration-none menu-link fs-5">
                          {faqItems.title}
                        </Link>
                        
                      </h6>
                      <div
                        className="fs-6 text-light-black"
                        
                      >
                        {limitWords(faqItems.faqFields?.content, 45)}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            )}

            <div className="pt-6">
              <h3 className="montserrat-black text-white mb-3">{ctaHeading}</h3>
              {ctaSubheading && (
                <div className="content-white">{parse(ctaSubheading)}</div>
              )}

              {ctaBtn?.title.length > 0 && (
                <Button
                  as={Link}
                  href={ctaBtn?.url}
                  size="lg"
                  className="mt-3 px-4 py-3 me-3 montserrat-bold fs-6 mx-auto text-light-black"
                  target={ctaBtn?.target}
                  variant="white"
                >
                  {ctaBtn?.title}
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      {/* </section> */}
    </section>
  );
};

export const sectionWrapper = (bgImage) => ({
  background: `linear-gradient(0deg, rgba(66, 148, 77, 0.95) 0%, rgba(66, 148, 77, 0.95) 100%), url(${bgImage}) center / cover no-repeat`,
});

export default FaqSection;
